import { Navigate } from 'react-router'
import type { NonIndexRouteObject, RouteObject } from 'react-router'
import BasicLayout from 'layout/BasicLayout'
import NotFound from 'pages/error/NotFound'
import { Roles } from 'api/login-model'
import { AppstoreOutlined, BarsOutlined, CarryOutOutlined, EditOutlined, FileDoneOutlined, HomeOutlined, ProfileOutlined, RobotOutlined, SolutionOutlined, UnorderedListOutlined, UserOutlined } from "@ant-design/icons"
import SurveyPage from 'pages/paper/SurveyPage'
import SignIn from 'pages/sign/SignIn'

// const IndexPage = lazy(() => import('pages/Index'))
const LoginPage = lazy(() => import('pages/user/Login'))
const OrganizationPage = lazy(() => import('pages/organization/Organization'))
const AccountPage = lazy(() => import('pages/account/Account'))
const MeetingPage = lazy(() => import('pages/meeting/Meeting'))
const MyMeetingPage = lazy(() => import('pages/meeting/MyMeeting'))
const MeetingConfigurationPage = lazy(
  () => import('pages/meeting/MeetingConfiguration')
)
const MeetingInvitationPage = lazy(
  () => import('pages/meeting/MeetingInvitation')
)

const MeetingInvitationRecordPage = lazy(
  () => import('pages/meeting/MeetingInvitationRecord')
)

const NameListPage = lazy(() => import('pages/name-list/NameList'))
const ResourcesPage = lazy(() => import('pages/resources/Resources'))
const SeriesPage = lazy(() => import('pages/series/Series'))
const LeadPage = lazy(() => import('pages/lead/Lead'))
const Feedback = lazy(() => import('pages/feedback/Feedback'))
const Egg = lazy(() => import('pages/egg/Egg'))
// import Resources from "pages/resources/Resources"
// const ResourcesPage = Resources


const CelebrationIcon = () => (
  <span role="img" aria-label="edit" className="anticon anticon-edit ant-menu-item-icon">
    <svg fill="currentColor" viewBox="0 0 24 24" style={{ width: '1em', height: '1em' }}><path d="m2 22 14-5-9-9zm12.53-9.47 5.59-5.59c.49-.49 1.28-.49 1.77 0l.59.59 1.06-1.06-.59-.59c-1.07-1.07-2.82-1.07-3.89 0l-5.59 5.59zm-4.47-5.65-.59.59 1.06 1.06.59-.59c1.07-1.07 1.07-2.82 0-3.89l-.59-.59-1.06 1.07.59.59c.48.48.48 1.28 0 1.76m7 5-1.59 1.59 1.06 1.06 1.59-1.59c.49-.49 1.28-.49 1.77 0l1.61 1.61 1.06-1.06-1.61-1.61c-1.08-1.07-2.82-1.07-3.89 0m-2-6-3.59 3.59 1.06 1.06 3.59-3.59c1.07-1.07 1.07-2.82 0-3.89l-1.59-1.59-1.06 1.06 1.59 1.59c.48.49.48 1.29 0 1.77"></path></svg>
  </span>
);

const BarChartIcon = () => (
  <span role="img" aria-label="edit" className="anticon anticon-edit ant-menu-item-icon">
    <svg fill="currentColor" viewBox="0 0 24 24" style={{ width: '1em', height: '1em' }}>
      <path d="M7.5 21H2V9h5.5zm7.25-18h-5.5v18h5.5zM22 11h-5.5v10H22z"></path>
      </svg>
  </span>
);

interface RouteItem extends NonIndexRouteObject {
  name?: string
  key: string
  hidden?: boolean
  children?: RouteItem[]
  roles?: Roles[]
  icon?:any
}

const routes: RouteItem[] = [
  {
    name: '登录',
    key: 'login',
    path: 'login',
    hidden: true,
    element: <LoginPage />
  },
  {
    key: 'BasicLayout',
    Component: BasicLayout,
    children: [
      // {
      //   name: '首页',
      //   key: 'index',
      //   path: '/',
      //   element: <IndexPage />
      // },
      {
        name: '组织管理',
        key: 'menu.organizational.management',
        path: '/organization',
        roles: [Roles.Admin],
        element: <OrganizationPage />,
        icon:<AppstoreOutlined />
      },
      {
        name: '账号管理',
        key: 'menu.account.management',
        path: '/account',
        roles: [Roles.Admin],
        element: <AccountPage />,
        icon:<UserOutlined />
      },
      {
        name: '会议管理',
        key: 'menu.meeting.management',
        path: '/meeting',
        roles: [Roles.Admin],
        element: <MeetingPage />,
        icon:<RobotOutlined />
      },
      {
        name: '活动申请',
        key: 'menu.meeting.lead',
        path: '/lead',
        roles: [Roles.Admin],
        element: <LeadPage />,
        icon:<SolutionOutlined />
      },      
      {
        name: '首页',
        key: 'menu.meeting.my-meeting',
        path: '/my-meeting',
        roles: [Roles.Business],
        // hidden: true,
        element: <MyMeetingPage />,
        icon:<HomeOutlined />
      },
      {
        name: '会议配置',
        key: 'menu.meeting.configuration',
        path: '/meeting-configuration',
        roles: [Roles.Business],
        element: <MeetingConfigurationPage />,
        icon:<AppstoreOutlined />
      },
      {
        name: '会议邀请',
        key: 'menu.meeting.meeting-invitation',
        path: '/meeting-invitation',
        roles: [Roles.Business],
        element: <MeetingInvitationPage />,
        icon:<SolutionOutlined />
      },
      {
        name: '名单管理',
        key: 'menu.meeting.name-list',
        path: '/name-list',
        roles: [Roles.Business],
        element: <NameListPage />,
        icon:<ProfileOutlined />
      },
      {
        name: '意见反馈',
        key: 'menu.meeting.feedback',
        path: '/feedback',
        roles: [Roles.Business],
        element: <Feedback />,
        icon:<EditOutlined />
      },      
      {
        name: '彩蛋记录',
        key: 'menu.meeting.egg',
        path: '/egg',
        roles: [Roles.Business],
        element: <Egg />,
        icon:<CelebrationIcon />
      },      
      {
        name: '试卷调查',
        key: 'menu.meeting.paper-survey',
        path: '/paper-survey',
        roles: [Roles.Business],
        element: <SurveyPage />,
        icon:<BarChartIcon />
      },      
      {
        name: '签到记录',
        key: 'menu.meeting.sign-in',
        path: '/sign-in',
        roles: [Roles.Business],
        element: <SignIn />,
        icon:<CarryOutOutlined />
      },            
      {
        name: '邀请记录',
        key: 'menu.meeting.meeting-invitation-list',
        path: '/meeting-invitation-list',
        roles: [Roles.Business],
        hidden: true,
        element: <MeetingInvitationRecordPage />,
        icon: <UnorderedListOutlined />
      },
      {
        name: '资源管理',
        key: 'menu.resources.management',
        path: '/resources',
        roles: [Roles.Maintenance],
        element: <ResourcesPage />,
        icon:<FileDoneOutlined />
      },
      {
        name: '资源系列',
        key: 'menu.resources.series',
        path: '/series',
        roles: [Roles.Maintenance],
        element: <SeriesPage />,
        icon:<BarsOutlined />
      }
      // {
      //   name: '日志管理',
      //   key: 'logging',
      //   path: '/logging',
      //   Component: Logging
      // },
      // {
      //   name: '配置管理',
      //   key: 'setting',
      //   path: '/setting',
      //   Component: Setting
      // }
    ]
  },
  {
    key: 'redirect-index',
    path: '/',
    element: <Navigate replace to="/login" />
  },
  {
    key: 'NotFound',
    path: '/*',
    Component: NotFound
  }
]

function transformRoute(routes: RouteItem[]): RouteObject[] {
  return routes.map(
    ({ path, Component, children, loader, index, element, lazy }) => {
      return {
        path,
        Component,
        loader,
        index,
        element,
        lazy,
        children: children && transformRoute(children)
      }
    }
  )
}

const routeConfig = transformRoute(routes)

export { routes }
export type { RouteItem }
export default routeConfig
